import { useState } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import styles from "./MainMenu.module.css";

const MainMenu = () => {
  const [hoveredLinkIndex, setHoveredLinkIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About Me" },
    { path: "/media", label: "Media Center" },
    { path: "/contact", label: "Contact Me" },
  ];

  const handleMouseEnter = (index) => setHoveredLinkIndex(index);
  const handleMouseLeave = () => setHoveredLinkIndex(null);

  return (
    <div className={styles.menuContainer}>
      <motion.div className={`${styles.menuIcon} ${isOpen ? styles.open : ""}`} onClick={toggleMenu}>
        <motion.div
          className={styles.line}
          animate={{ rotate: isOpen ? 45 : 0, y: isOpen ? 8.6 : 0 }}
          transition={{ duration: 0.2 }}
        />
        <motion.div
          className={styles.line}
          animate={{ opacity: isOpen ? 0 : 1 }}
          transition={{ duration: 0.3 }}
        />
        <motion.div
          className={styles.line}
          animate={{ rotate: isOpen ? -45 : 0, y: isOpen ? -8.6 : 0 }}
          transition={{ duration: 0.2 }}
        />
      </motion.div>

      <motion.div
        className={styles.navMenu}
        initial={{ opacity: 0, clipPath: "circle(0% at 50% 50%)" }}
        animate={{
          opacity: isOpen ? 1 : 0,
          clipPath: isOpen ? "circle(150% at 50% 50%)" : "circle(0% at 50% 50%)"
        }}
        transition={{ duration: 0.5 }}
      >
        <nav>
          <ul className={styles.navLinks}>
            {navLinks.map((link, index) => (
              <li key={index} className={styles.navItem}>
                <NavLink
                  to={link.path}
                  activeClassName={styles.active}
                  className={`${styles.navLink} ${
                    hoveredLinkIndex !== null && hoveredLinkIndex !== index
                      ? styles.otherLinks
                      : ""
                  }`}
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}
                  onClick={toggleMenu}
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </motion.div>
    </div>
  );
};

export default MainMenu;